import { EnvironmentContextProvider } from '@ds-mgnl/marketing';
import type { LinkSourceProps, LinkSourceRecord } from '@dsx/react';
import { Provider as DsxProvider } from '@dsx/react';
import { forwardRef } from 'react';
import {
	Outlet,
	Link as RouterLink,
	RouterProvider,
	ScrollRestoration,
	createBrowserRouter,
} from 'react-router-dom';
import { Footer } from './components/Footer';
import { useUtmFormTracking } from './hooks/useUtmFormTracking';
import { getMagnoliaBaseDamUrl, getMagnoliaBaseUrl } from './util';
import { magnoliaPageLoader } from './pages/magnoliaPageLoader';
import { ErrorPage } from './pages/ErrorPage';
import { MagnoliaPage } from './pages/MagnoliaPage';

const linkSources = {
	default: forwardRef<HTMLAnchorElement, LinkSourceProps>((props, ref) => (
		<RouterLink ref={ref} {...props} to={props.href || ''} />
	)),
	external: forwardRef<HTMLAnchorElement, LinkSourceProps>((props, ref) => (
		<a ref={ref} {...props} />
	)),
	none: forwardRef<HTMLSpanElement, LinkSourceProps>((props, ref) => (
		<span ref={ref} {...props} />
	)),
} as LinkSourceRecord;

const router = createBrowserRouter([
	{
		element: <RootLayout />,
		children: [
			{
				path: '*',
				element: <MagnoliaPage />,
				loader: magnoliaPageLoader,
				errorElement: <ErrorPage />,
			},
		],
	},
]);

export function App() {
	useUtmFormTracking();

	return (
		<DsxProvider locale="en-US" linkSources={linkSources}>
			<EnvironmentContextProvider
				value={{
					damHost: getMagnoliaBaseDamUrl() ?? '',
					appHost: getMagnoliaBaseUrl() ?? '',
					isInMagnolia: false,
				}}
			>
				<RouterProvider router={router} />{' '}
			</EnvironmentContextProvider>
		</DsxProvider>
	);
}

function RootLayout() {
	return (
		<div>
			<main>
				<Outlet />
			</main>
			<Footer />
			<ScrollRestoration />
		</div>
	);
}
